import { render, staticRenderFns } from "./speakerCards.vue?vue&type=template&id=63d9e54a&"
import script from "./speakerCards.ts?vue&type=script&lang=js&"
export * from "./speakerCards.ts?vue&type=script&lang=js&"
import style0 from "../../../comStyle/comStyle.less?vue&type=style&index=0&lang=less&"
import style1 from "./speakerCards.less?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports